/**
 * NotActivity Component
 *
 * Features:
 * - Manages the view between activity instructions and activity upload.
 * - Uses useState to toggle between instructions and upload.
 * - Passes necessary props to ActivityUpload for handling homework status, course, lesson, and navigation.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';

import ActivityInstructions from '../ActivityInstructions/ActivityInstructions';
import ActivityUpload from '../ActivityUpload/ActivityUpload';

const NotActivity = props => {
  // State to toggle between instructions and upload view
  const [uploadActivity, setUploadActivity] = useState(false);

  const changeViewHandler = () => {
    setUploadActivity(!uploadActivity);
  };

  return (
    <>
      {!uploadActivity && (
        /* Props passed to ActivityInstructions:
           - changeView: changeViewHandler (function to toggle view)
        */
        <ActivityInstructions changeView={changeViewHandler} />
      )}
      {uploadActivity && (
        /* Props passed to ActivityUpload:
           - returnVideo: props.returnVideo (function)
           - changeView: changeViewHandler (function)
           - idCourse: props.idCourse (number)
           - idLesson: props.idLesson (number)
           - changeHomeworkStatus: props.changeHomeworkStatus (function)
        */
        <ActivityUpload
          returnVideo={props.returnVideo}
          changeView={changeViewHandler}
          idCourse={props.idCourse}
          idLesson={props.idLesson}
          changeHomeworkStatus={props.changeHomeworkStatus}
        />
      )}
    </>
  );
};

NotActivity.propTypes = {
  /**
   * Course ID
   */
  idCourse: PropTypes.number,
  /**
   * Lesson ID
   */
  idLesson: PropTypes.number,
  /**
   * Function to return to the video
   */
  returnVideo: PropTypes.func,
  /**
   * Function to change the homework status
   */
  changeHomeworkStatus: PropTypes.func
};

NotActivity.defaultProps = {
  idCourse: null,
  idLesson: null,
  returnVideo: () => {},
  changeHomeworkStatus: () => {}
};

export default NotActivity;
